<template>
  <nuxt-link
    :to="link"
    :class="[sizeClass, toneClass]"
    class="group inline-flex items-center gap-x-1.5 font-semibold transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600"
  >
    {{ label }}

    <icon
      v-if="iconName"
      :name="iconName"
      aria-hidden="true"
      class="size-4 transition group-hover:translate-x-0.5"
    />
  </nuxt-link>
</template>

<script setup lang="ts">
import type { ButtonSecondaryProps } from 'types/button'

const { iconName, size = 'md', inverted = false } = defineProps<ButtonSecondaryProps>()

const sizeClass = computed(() => {
  if (size === 'sm') return 'text-sm'
  if (size === 'lg') return 'text-base'
  return 'text-sm/6'
})

const toneClass = computed<string>(() => {
  if (inverted) return 'text-white hover:text-brand-300 active:text-brand-300'

  return 'text-gray-900 hover:text-brand-700 active:text-brand-700'
})
</script>
